import A11yDialog from 'a11y-dialog';
import { getElement, getElements, ifSelectorExist } from './utils';
export const modalDialog = () => {
  
  const dialogContainer = document.querySelector('#testimonialDialog');
  if (ifSelectorExist(dialogContainer)) {
    const videoReviewsDialog = new A11yDialog(dialogContainer);

    let fireTestimonialModalSelector = getElements('.fireTestimonialModal');
    if (ifSelectorExist(fireTestimonialModalSelector)) {
      Array.from(fireTestimonialModalSelector).forEach((item) => {
        item.addEventListener('click', () => {
          
          console.log('clicked by modal button');
          let testimonialVideoIdSelector = getElement('#testimonialVideoIdSelector');
          if (ifSelectorExist(testimonialVideoIdSelector)) {
            let itemYtUrl = item.getAttribute('data-yt-url');
            testimonialVideoIdSelector.src = itemYtUrl;
          }
        });
      });
    }

    videoReviewsDialog.on('hide', function (dialogEl, event) {
      dialogEl.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });

    videoReviewsDialog.on('show', function (dialogEl, event) {
      dialogEl.querySelector('iframe').onload = () => {
        dialogEl.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      };
    });

  }
};

export const adaModal = () => {
  let modalWindow = getElement('.ada-modal-window');
  let modalWindowClose = getElement('.ada-modal-window--close');
  let modalWindowOpen = getElements('.ada-modal-window--open');

  // Functions
  let openModal = () => {
      modalWindow.classList.add('open');
      document.body.style.overflow = 'hidden';
  }

  let closeModal = () => {
      modalWindow.classList.add('fade-out');
      setTimeout(() => {
          modalWindow.classList.remove('open', 'fade-out');
          document.body.style.overflow = null;
      }, 300);
  }

  if (ifSelectorExist(modalWindowOpen)) {
    Array.from(modalWindowOpen).forEach((item) => {
      item.addEventListener('click', () => {
        openModal();
      });
    });
  }

  if (ifSelectorExist(modalWindow)) {
      modalWindow.addEventListener('click', (e) => {
          if (e.target === modalWindow) {
              closeModal();
          }
      });  

      window.onkeydown = (e) => {
          if (e.key === "Escape") {
              closeModal();
          }
      }
  }

  if (ifSelectorExist(modalWindowClose)) {
      modalWindowClose.addEventListener('click', () => {
          closeModal();
      })
  }
}